@import 'styles/mixins';
@import 'styles/variables';

$emojiHeight: 80px;
$editorContainerVerticalMargin: 80px;

.container {
  background: $white;
  position: relative;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  overflow: visible;
  height: max-content;
  --conditional-banner-height: 0px;
  --total-navbar-height: calc(var(--conditional-banner-height) + #{$action-bar-height});

  &.isExternalFile {
    --total-navbar-height: calc(
      var(--conditional-banner-height) + #{$action-bar-height} + 2px
    ); // 2px for top and bottom borders of mainContainer
  }

  .content {
    height: max-content;
  }

  &.notInEditorMode {
    height: calc(100vh - #{$action-bar-height});
  }

  &.withUnregisteredBanner {
    --conditional-banner-height: var(--unregistered-banner-height);
    --total-navbar-height: calc(var(--unregistered-banner-height) + #{$action-bar-height});

    aside {
      top: var(--total-navbar-height);
      height: calc(100% - var(--total-navbar-height));
      min-height: calc(100vh - var(--total-navbar-height));
    }

    .content {
      height: calc(100vh - var(--total-navbar-height));
    }
  }

  @include for-phone-only {
    border-radius: 0;
  }

  &.hidden {
    display: none;
  }
}

.editorContainer {
  width: 100%;
  max-width: 900px;
  margin-top: $editorContainerVerticalMargin;
  padding-bottom: 50px;
  display: flex;
  flex-direction: column;
  position: relative;

  &.withAiBar {
    padding-bottom: 72px;
  }

  @media (min-width: $tabletPortraitMinWidth) and (max-width: $proseEditSmallWidth_deprecated) {
    width: calc(100% - $neruda-toc-width);
  }

  @include for-tablet-portrait-down {
    margin-top: 15px;
  }

  [data-layout='fluid'] & {
    max-width: initial;
  }
}

.editorContainerHidden {
  visibility: hidden;
}

.contentContainer {
  display: flex;
  justify-content: center;
  height: 100%;
  min-height: initial;
}

.loadContainer {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.title:global(.ant-input) {
  @include header-xxl-serif;

  line-height: 56px !important;
  color: $gray-90;
  background: transparent;
  margin-bottom: 24px;
  padding: 0;
  border: none;
  resize: none;
  box-shadow: none !important;

  &::placeholder {
    color: $gray-40;
  }
}

.coverRow {
  width: 100%;
  max-width: 900px;
  display: flex;
  justify-content: space-between;
  padding: 16px 0;
  margin-top: -75px;
}

.coverImageMargin {
  margin-top: 20px;
}

// NOTE: this class is used by the format menu to determine clicks outside the editor
.columnContainer {
  display: flex;
  justify-content: space-between;
  width: 100%;

  @media (max-width: $proseEditColContainerSmallWidth_deprecated) {
    justify-content: center;
  }

  @include for-desktop-up {
    justify-content: space-between;
  }

  @include for-tablet-portrait-down {
    padding: 0 14px;

    &.locked {
      padding-bottom: 0;
    }
  }

  &.locked {
    padding-bottom: 0;
  }

  &.inCore {
    background-image: url('../../assets/img/core-doc-background.png');
    background-repeat: no-repeat;
  }

  &.scrollMarginTop {
    [id] {
      scroll-margin-top: $workflow-bar-height;
    }
  }
}

.columnContainer__withImage {
  @extend .columnContainer;
  padding-top: 0;
}

.articleContentsContainer {
  @include transition(0.6s);
  width: 100%;

  &.fullHeight {
    height: 100%;
  }
}

.leftColumn,
.rightColumn {
  width: $neruda-toc-width;

  &.inCore {
    margin-right: unset;
    width: unset;
  }

  @include for-phone-only {
    width: unset;
  }
}

.midColumn {
  flex: 3 0 0;
  max-width: $editor-max-width;
  margin: 0;
  width: calc(100% - $neruda-toc-width);

  @media (min-width: $proseEditMidColContainerLargeWidth_deprecated) {
    margin: 0 $editor-side-margin;
  }

  @include for-phone-only {
    width: 100%;
  }

  &.inCore {
    margin: 0 auto;
    max-width: 920px;
  }

  [data-layout='fluid'] & {
    max-width: initial;
  }
}

.nerudaTocContainer {
  display: flex;
  height: calc(100vh - var(--neruda-toolbar-bravo-height) - #{$action-bar-height});
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 2;
  opacity: 1;
  transition: opacity 0.2s ease-in-out;

  > div {
    flex-grow: 1;
  }
}

.readTitle {
  @include publico-medium;
  display: flex;
  font-size: 52px;
  line-height: 62px !important;
  color: $gray-90;
  margin-bottom: 24px;
  border: none;
}

.stickySocialContainer {
  height: 100%;
  margin-top: 115px;

  @include for-tablet-portrait-down {
    display: none;
  }
}

.stickySocial {
  position: sticky;
  top: 251px;
  width: 44px;
}

.belowActionBarContainer {
  display: flex;

  &.fullHeight {
    height: 100%;
  }

  &.externalResource {
    flex-direction: column;

    .rightRailExternalResource {
      padding-top: calc(100vh - $action-bar-height - 16px);
      margin: 6px;
    }
  }
}

.emojiRow {
  display: flex;
}

.locked {
  .emojiRow {
    margin-top: -30px;
  }
}

.emojiRow__coverAndPhoto {
  @extend .emojiRow;
  margin-top: -30px;
}

.banner {
  margin: map-get($spacers, 3);
}

.suggestedDocs {
  border-top: 1px solid $gray-20;
  padding: 48px 0 48px 48px;
  display: grid;

  .heading {
    @include header-md;

    color: $almanac-black;
    margin-bottom: 24px;
  }
}

.articleReader {
  margin-bottom: 24px;
}

.taxonomyEdit,
.taxonomyRead {
  margin: 0 -16px 24px;
}

.tagList {
  display: inline-block;
  margin-top: 12px;
}

.content {
  display: flex;
  flex-flow: row;
  height: initial;

  &.compareContent {
    height: calc(100vh - #{$compare-header-height});
  }
}

:global(.in-layer-view) {
  .content {
    border-radius: 16px 16px 0 0;
  }
}

.main {
  width: 100%;
  overflow-y: auto;
  @include rightRailTransition(width, margin);
  @include thinScrollbar;
  height: calc(100% + $frame-wrapper-margin-offset);

  .presencesOutOfViewContainer {
    transition: width 0.6s ease-in-out;
    width: calc((100% - #{$editor-max-width} - #{2 * $editor-side-margin} - #{$right-rail-selector-width}) / 2);
  }

  &.rightNavOpen {
    width: calc(100% - var(--right-rail-total-width));
    margin-right: var(--right-rail-total-width);

    .presencesOutOfViewContainer {
      width: calc((100% - #{$editor-max-width} - #{2 * $editor-side-margin} - #{var(--right-rail-total-width)}) / 2);
    }
  }

  &.externalResource {
    transition: none;
  }

  &.noRightRail {
    width: 100%;
    margin-right: 0;
  }

  [data-design-system='blaze'] & {
    overflow: visible;
  }
}

.aside {
  @include z-index(rightRail);
  position: fixed;
  left: calc(100% - #{$right-nav-rail-width});
  opacity: 1;
  max-width: $right-nav-rail-width;
  min-width: $right-nav-rail-width;
  background-color: $white;
  top: $action-bar-height;
  height: calc(100% - #{$action-bar-height});
  min-height: calc(100vh - #{$action-bar-height});
  overflow: hidden;

  @include for-tablet-portrait-down {
    position: fixed;
    left: 0;
    top: 0;
    max-width: 100%;
    height: 100%;
    min-width: 100%;
  }
}

.leftRailClosed .aside {
  @media (min-width: $proseEditColContainerSmallWidth_deprecated) and (max-width: $proseEditLargeWidth_deprecated) {
    box-shadow: 0 8px 8px rgba(19, 21, 26, 0.12), 0 1px 1px rgba(34, 41, 59, 0.12);
    position: absolute;
    top: auto;
  }
}

.leftRailOpen .aside {
  @media (min-width: $proseEditColContainerSmallWidth_deprecated) and (max-width: $proseEditLargeWidthWithLeftRail_deprecated) {
    box-shadow: 0 8px 8px rgba(19, 21, 26, 0.12), 0 1px 1px rgba(34, 41, 59, 0.12);
    position: absolute;
    top: auto;
  }
}

.asideWithTabSelector {
  left: calc(100% - #{$right-nav-rail-width});

  &.superAdminMode {
    left: calc(100% - #{$right-nav-rail-width} - #{$super-admin-outline-width});
  }

  @media (max-width: $docRightRailMediumWidth_deprecated) {
    left: calc(100% - #{$right-nav-rail-width});

    &.superAdminMode {
      left: calc(100% - #{$right-nav-rail-width} - #{$super-admin-outline-width});
    }
  }

  @include for-tablet-portrait-down {
    position: fixed;
    top: 0;
    max-width: 100%;
    height: 100%;
    min-width: 100%;
  }
}

.noNavbar {
  @include transition(0.6s);
}

.asideMergeScreen {
  @extend .aside;
  top: 64px;
  height: 100vh;
}

.threadViewComponentPlaceholder {
  display: block;
}

.asideHidden {
  @include z-index(hiddenAside);
  left: 100%;
  position: fixed;
  opacity: 0;
}

.headerBar {
  @include z-index(proseEditHeaderBar);
  background: $white;
  border-bottom: 1px solid $gray-20;
  position: sticky;
  top: 0;
  min-height: 64px;
  grid-template-columns: auto $right-nav-rail-width;
  display: grid;

  @include for-tablet-portrait-down {
    display: block;
    padding: 8px;
  }
}

.selectorContainer {
  @include focus-mode-transition;
  @include z-index(rightRailSelector);

  width: $right-rail-selector-width;
}

.nerudaToolbarContainer {
  @include transition(0.3s);

  @include for-tablet-landscape-down {
    display: none;
  }

  &.notInEditorMode {
    transform: translateY(-#{$nav-bar-height + 1px});
  }
}

.lockedBanner {
  margin: 23px -#{$editor-side-margin} 27px -#{$editor-side-margin};
}

.hiddenInput {
  opacity: 0;
  height: 0;
  width: 0;
  overflow: hidden;
  outline: none;
  position: fixed;
  top: 50%;
  left: 50%;
}

.observingTag {
  @include transition(0.6s);
  position: absolute;
  background: blue;
  color: white;
  right: $right-nav-rail-width;
  bottom: 0;
  padding: 4px;
  @include xxs-medium;
  border-radius: 2px 0px 0px 0px;

  &.toTheRight {
    right: $right-rail-selector-width;
  }
}

.docObserversContainer {
  @include transition(0.6s);
  position: absolute;
  top: calc(var(--total-navbar-height) + 12px);
  right: $right-nav-rail-width + 14px;

  &.toTheRight {
    right: $right-rail-selector-width + 14px;
  }
}
